export default __webpack_public_path__ + "static/media/panel-bkg-medium.14a18bcc.png";